import { render, staticRenderFns } from "./MMLGLOBAL.vue?vue&type=template&id=5da25a43&"
import script from "./MMLGLOBAL.vue?vue&type=script&lang=js&"
export * from "./MMLGLOBAL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports